import {ViewDefinition} from "./view-definition";
import {ViewModelType} from "../type/view-model-type.enum";
import {TableOperationDefinition} from "../table-operation/table-operation-definition";
import {FormDisplayType} from "../type/form-display-type.enum";

type TableOperationFilter = (operation: TableOperationDefinition, viewModelType: ViewModelType) => boolean;

/**
 * NOTE: many of the fields in this model might have to be on the ContentModel instead. Currently
 * some are duplicated (like event executor).
 */
export class ViewModel {
  private readonly definition: ViewDefinition;
  private eventExecutor: any;
  private formContext: string;
  private parentContext: string;
  private formDisplayType: FormDisplayType;
  private queryBuilder: any;
  private isRecordSyncDisabled: boolean = false;
  private tableOperationFilter: TableOperationFilter;

  public ViewModelType = ViewModelType;

  constructor(definition: ViewDefinition) {
    this.definition = definition;
  }

  viewDefinition() {
    return this.definition;
  }

  getAspect(): string {
    return this.definition.aspect;
  }

  getID(): string {
    return this.definition.id;
  }

  getName(): string {
    return this.definition.viewName;
  }

  getTitle(): string {
    return this.definition.title;
  }

  getTableName(): string {
    return this.definition.table;
  }

  getViewModelType(): ViewModelType {
    return this.definition.viewModelType;
  }

  setEventExecutor(eventExecutor: any) {
    this.eventExecutor = eventExecutor;
  }

  getEventExecutor(): any {
    return this.eventExecutor;
  }

  setFormContext(formContext: string) {
    this.formContext = formContext;
  }

  getFormContext(): string {
    return this.formContext;
  }

  // Track parent form context to trace which page/form initiated a modal
  getParentContext(): string {
    return this.parentContext;
  }

  setParentContext(parentContext: string) {
    this.parentContext = parentContext;
  }

  getIsRecordSyncDisabled(): boolean {
    return this.isRecordSyncDisabled;
  }

  setIsRecordSyncDisabled(isRecordSyncDisabled: boolean) {
    this.isRecordSyncDisabled = isRecordSyncDisabled;
  }

  setFormDisplayType(formDisplayType: FormDisplayType) {
    this.formDisplayType = formDisplayType;
  }

  getFormDisplayType(): FormDisplayType {
    return this.formDisplayType;
  }

  setQueryBuilder(queryBuilder: any) {
    this.queryBuilder = queryBuilder;
  }

  getQueryBuilder(): any {
    return this.queryBuilder;
  }

  setTableOperationFilter(tableOperationFilter: TableOperationFilter) {
    this.tableOperationFilter = tableOperationFilter;
  }

  getTableOperationFilter(): TableOperationFilter {
    return this.tableOperationFilter;
  }

  private getDefaultedField(property: any, defaultValue?: any) {
    const value = this.definition[property];
    return value !== null && value !== undefined ? value : defaultValue;
  }

  static create(definition: ViewDefinition): ViewModel {
    return new ViewModel(definition);
  }
}

// _eventExecutor: undefined,
